export { View as FixedScreen } from './view'
